<template>
  <v-container>
    <v-card class="elevation-4 rounded-lg">
      <v-card-title class="headline white--text pa-4" style="background-color: #005f32;">
        Send Automated Email
      </v-card-title>
      <v-card-text class="pt-6">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" md="6">
              <v-combobox
                id="toEmailField"
                name="toEmailField"
                v-model="toEmail"
                :items="employees"
                item-text="email"
                item-value="email"
                return-object
                autocomplete="new-password"
                label="To (Emails)"
                placeholder="Search by email or name, or type external email"
                outlined
                dense
                multiple
                chips
                :search-input.sync="searchEmail"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    small
                    color="grey lighten-3"
                    class="px-1 mt-2 mb-1"
                    @click="data.select"
                    @click:close="removeToEmail(data.item)"
                  >
                    {{ typeof data.item === 'object' && data.item !== null ? data.item.name : data.item }}
                  </v-chip>
                </template>
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on" #default="{ active }">
                    <v-list-item-action>
                      <v-simple-checkbox :value="active" color="primary" style="pointer-events: none;"></v-simple-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ typeof item === 'object' && item !== null ? item.email : item }}</v-list-item-title>
                      <v-list-item-subtitle v-if="typeof item === 'object' && item !== null">{{ item.name }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                id="ccEmailField"
                name="ccEmailField"
                v-model="ccEmails"
                :items="employees"
                item-text="email"
                item-value="email"
                return-object
                autocomplete="new-password"
                label="CC (Emails)"
                placeholder="Search by email or name, or type external email"
                outlined
                dense
                multiple
                chips
                :search-input.sync="searchCcEmail"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    small
                    color="grey lighten-3"
                    class="px-1 mt-2 mb-1"
                    @click="data.select"
                    @click:close="removeCcEmail(data.item)"
                  >
                    {{ typeof data.item === 'object' && data.item !== null ? data.item.name : data.item }}
                  </v-chip>
                </template>
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on" #default="{ active }">
                    <v-list-item-action>
                      <v-simple-checkbox :value="active" color="primary" style="pointer-events: none;"></v-simple-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ typeof item === 'object' && item !== null ? item.email : item }}</v-list-item-title>
                      <v-list-item-subtitle v-if="typeof item === 'object' && item !== null">{{ item.name }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12">
              <v-radio-group v-model="sendType" row class="mt-0 pt-0">
                <v-radio label="Send as group" value="group" color="#005f32"></v-radio>
                <v-radio label="Send separately" value="separately" color="#005f32"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedAction"
                :items="actions"
                item-text="name"
                return-object
                label="Select Action"
                outlined
                dense
                @change="onActionSelected"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="subject"
                label="Subject"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="body"
                label="Email Body"
                outlined
                auto-grow
                rows="8"
                :hint="'The ' + '{' + '{name}} placeholder will be automatically replaced with the selected employee\'s name.'"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <span class="text-subtitle-1">Attachments</span>
              <v-file-input
                v-model="attachments"
                multiple
                outlined
                dense
                prepend-icon="mdi-paperclip"
                label="Upload Attachments"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="clearForm">Clear</v-btn>
        <v-btn color="#005f32" class="white--text" @click="sendEmail" :loading="loading">
          Send Email
          <v-icon right dark>mdi-send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="snackbarColor" top right :timeout="3000">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "SendEmail",
  data() {
    return {
      valid: false,
      loading: false,
      toEmail: [],
      ccEmails: [],
      sendType: 'group',
      subject: "",
      body: "",
      originalBody: "",
      attachments: [],
      actions: [],
      selectedAction: null,
      employees: [],
      searchEmail: "",
      searchCcEmail: "",
      selectedEmployeeName: "Employee",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  watch: {
    searchEmail(val) {
      if (val && val.length > 2) {
        this.fetchEmployees(val);
      } else if (!val) {
        this.fetchEmployees("");
      }
    },
    searchCcEmail(val) {
      if (val && val.length > 2) {
        this.fetchEmployees(val);
      } else if (!val) {
        this.fetchEmployees("");
      }
    },
    toEmail(val) {
      if (!val || val.length === 0) {
        this.selectedEmployeeName = "Employee";
      } else {
        if (val.some(item => typeof item === 'string')) {
          this.toEmail = val.map(item => typeof item === 'string' ? { email: item, name: item } : item);
          return;
        }
        const firstItem = val[0];
        if (typeof firstItem === 'object' && firstItem !== null && firstItem.name) {
          this.selectedEmployeeName = firstItem.name;
        } else {
          this.selectedEmployeeName = "Employee";
        }
      }
      this.updateBody();
    },
    ccEmails(val) {
      if (val && val.length > 0 && val.some(item => typeof item === 'string')) {
        this.ccEmails = val.map(item => typeof item === 'string' ? { email: item, name: item } : item);
      }
    }
  },
  created() {
    this.fetchActions();
    this.fetchEmployees("");
  },
  methods: {
    showToast(message, color = "success") {
      this.snackbarText = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    async fetchActions() {
      try {
        const response = await axios.get(
          "/admin/email-actions/all",
          { headers: { "x-auth-token": localStorage.getItem("token") } }
        );
        this.actions = response.data;
      } catch (error) {
        console.error("Error fetching actions", error);
      }
    },
    async fetchEmployees(keyword) {
      try {
        // Using /view/employeelist to get employees based on keyword
        const response = await axios.post(
          "/view/employeelist",
          { page: 1, limit: 50, keyword: keyword },
          { headers: { "x-auth-token": localStorage.getItem("token") } }
        );
        if (response.data && response.data.data) {
          // Format the data for the autocomplete, excluding Super Admin
          this.employees = response.data.data
            .filter(emp => {
              const email = emp.email || (emp.eid && emp.eid.email);
              return email && email.toLowerCase() !== 'admin@wti.org';
            })
            .map(emp => ({
              email: emp.email || emp.eid.email,
              name: emp.name || (emp.eid && emp.eid.name) || "Employee"
            }));
        }
      } catch (error) {
        console.error("Error fetching employees", error);
      }
    },

    onActionSelected(action) {
      if (action) {
        this.subject = action.subject;
        this.originalBody = action.body;
        this.updateBody();
      }
    },
    removeCcEmail(item) {
      const index = this.ccEmails.indexOf(item);
      if (index >= 0) this.ccEmails.splice(index, 1);
    },
    removeToEmail(item) {
      const index = this.toEmail.indexOf(item);
      if (index >= 0) this.toEmail.splice(index, 1);
    },
    updateBody() {
      if (this.originalBody) {
        this.body = this.originalBody.replace(/\{\{\s*name\s*\}\}/gi, this.selectedEmployeeName);
      }
    },
    clearForm() {
      this.toEmail = [];
      this.ccEmails = [];
      this.sendType = 'group';
      this.selectedAction = null;
      this.subject = "";
      this.body = "";
      this.originalBody = "";
      this.attachments = [];
      this.selectedEmployeeName = "Employee";
      this.$refs.form.resetValidation();
    },
    async sendEmail() {
      if (!this.toEmail) {
        return this.showToast("Please provide a recipient email", "error");
      }
      if (!this.subject || !this.body) {
        return this.showToast("Subject and body are required", "error");
      }

      this.loading = true;
      const formData = new FormData();
      
      if (this.toEmail && this.toEmail.length > 0) {
        const toEmailsList = this.toEmail.map(item => typeof item === 'object' && item !== null ? item.email : item).join(',');
        formData.append("toEmail", toEmailsList);
      }
      
      if (this.ccEmails && this.ccEmails.length > 0) {
        const ccEmailsList = this.ccEmails.map(item => typeof item === 'object' && item !== null ? item.email : item).join(',');
        formData.append("ccEmails", ccEmailsList);
      }
      
      formData.append("sendType", this.sendType);
      formData.append("subject", this.subject);
      formData.append("body", this.body);

      if (this.attachments && this.attachments.length > 0) {
        for (let i = 0; i < this.attachments.length; i++) {
          formData.append("attachments", this.attachments[i]);
        }
      }

      try {
        await axios.post(
          "/admin/email-actions/send",
          formData,
          {
            headers: {
              "x-auth-token": localStorage.getItem("token"),
              "Content-Type": "multipart/form-data"
            }
          }
        );
        this.showToast("Email sent successfully");
        this.clearForm();
      } catch (error) {
        console.error("Error sending email", error);
        this.showToast((error.response && error.response.data && error.response.data.error) || "Failed to send email", "error");
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>
